import React, { Component } from 'react'
import { Input, Cascader, Button, Radio, Spin } from 'antd'
// 获取封装好的URL和app方法
import { app, api } from '../../../app'


const RadioGroup = Radio.Group


class InformationFilling extends Component {
    // 组件内部
    constructor(props) {
        super(props)
        let Editor = 1
        if (props.Editor != undefined) {
            Editor = 2
        }

        this.state = {
            // 【队伍信息填写数据】

            provinceList: [],   // Cascader组件所有城市信息数据
            cascaderInfo: [],    // Cascader组件所选定的城市
            defaultCity: '',
            teamName: "",       // input队伍名称
            teamflag: null,
            // 【队伍信息填写数据end】


            // 【申请人信息填写数据】

            applicationManName: '',      //申请人姓名
            applicationManId: '',        //申请人身份证号
            applicationManPhone: '',     //申请人电话号码
            MessageVerification: '',     //申请人短信验证码
            applicationManSex: '',        //申请人性别

            // 【申请人信息填写数据end】
            Editor: Editor,


            spin: true


        }

        this.getCityInfo()  //公共
        this.getStorageInfo()   //暂存
        this.getApplyinfo() //申请


    }

    componentDidMount() {
        this.isLogin()  //公共
        this.getExamineInfo()   //审核

        this.setState({
            spin: false
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.applyinfo !== this.props.applyinfo) {
            // 值发生改变下一步工作
            this.getApplyinfo()
        }
        if (nextProps.examineInfo !== this.props.examineInfo) {
            // 值发生改变下一步工作
            this.getExamineInfo()
        }

    }
    // 公共
    //判断是否登录
    isLogin = () => {
        //当用户处于登录状态(有账号)，那么应该获取账号的姓名和身份证号，且不允许用户自己编辑，当用户退出登录后就不再禁用用户编辑
        // console.log(app.getData('vname'))
        // console.log(app.getData('idno'))
        if (app.getData('vname') != '' || undefined) {
            this.setState({
                applicationManName: app.getData('vname'),
                applicationManId: app.getData('idno')
            })
        }
    }
    //  请求城市信息
    getCityInfo = () => {
        // 发送请求获取城市
        app.post(api.TeamProvinceCityList, {
        }).then(res => {
            // console.log(res)
            if (res.flag === 1) {
                let provinceList = res.data.map((pro) => {
                    return {
                        label: pro.area_name,
                        value: pro.id,
                        children: (pro.city || []).map((city) => {
                            return {
                                label: city.city_name,
                                value: city.city_id,
                            }
                        }),
                    }
                })
                this.setState({
                    provinceList,
                })
            } else {
                app.alert("错误", "error")
            }
        })

    }

    //  获取选择的城市
    getCity = (e) => {
        // console.log(e)
        const [city, bianhao] = e
        this.setState({
            cascaderInfo: e
        },()=>{
            this.putPropsInfo()
        })
        
    }

    // 获取队伍名称
    getTeamName = (event) => {
        this.setState({
            teamName: event.target.value.trim()
        }, () => {
            this.putPropsInfo()

        })

    }

    // 获取申请人姓名
    applicationManNameOnchange = (e) => {
        this.setState({
            applicationManName: e.target.value.trim()
        }, () => {
            this.putPropsInfo()

        })
    }

    // 获取申请人身份证号
    applicationManIdOnchange = (e) => {
        // let p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        // console.log(p.test("11010519491231002X"));
        this.setState({
            applicationManId: e.target.value.trim()
        }, () => {
            this.putPropsInfo()

        })

    }

    // 获取申请人电话号码
    applicationManPhoneOnchange = (e) => {
        this.setState({
            applicationManPhone: e.target.value.trim()
        }, () => {
            this.putPropsInfo()

        })
    }

    // 点击获取短信验证码
    clickGetMessageVerification = () => {
        const { applicationManPhone } = this.state
        let p = /^1\d{10}$/;
        // console.log(applicationManPhone)
        if (p.test(applicationManPhone)) {

            app.post(api.TeamApplySendSMS, { mobile: applicationManPhone }).then(res => {
                // console.log(res)
                if (res.flag == 1 && res.msg == "验证码发送成功") {
                    app.alert(res.msg, "success")
                    // 接口调用成功

                } else {
                    app.alert(res.msg, "success")
                }

            })
        } else {
            app.alert("电话号码格式错误", "error")

        }
    }

    // 获取申请人短信验证码
    applicationManMessageVerificationOnchange = (e) => {
        this.setState({
            MessageVerification: e.target.value.trim()
        }, () => {
            this.putPropsInfo()

        })
    }

    // 获取性别
    sexChange = (e) => {
        this.setState({
            applicationManSex: e.target.value.trim()
        }, () => {
            this.putPropsInfo()
        })
    }


    putPropsInfo = () =>{
        const state = this.state;
        let info = {
            cascaderInfo: state.cascaderInfo,
            teamName: state.teamName,
            applicationManName: state.applicationManName,
            applicationManId: state.applicationManId,
            applicationManPhone: state.applicationManPhone,
            applicationManSex: state.applicationManSex,
            MessageVerification: state.MessageVerification,
            cascaderInfo: state.cascaderInfo
        }
        if(this.props.putModalInfo != undefined){
            this.props.putModalInfo(info)

        }
    }
    // 跳转回上一步
    golast = () => {
        // 需要问询用户是否要返回上一页
        this.props.setPage(1);
    }

    // 跳转到下一步
    goNext = () => {
        // 对数据进行验证
        const { cascaderInfo, teamName, applicationManName, applicationManId, applicationManPhone, MessageVerification, applicationManSex } = this.state
        if (this.state.teamflag) {  //验证是否完成队伍信息填写查询操作
            if (applicationManName != '') { //验证申请人姓名
                if (applicationManId != '') { //验证申请人身份证号码

                    if (applicationManPhone != '') { //验证申请人电话号码
                        if (MessageVerification != '') { //验证短信验证码
                            if (applicationManSex != '') { //验证性别
                                // // 正则表达式
                                let p = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
                                if (p.test(applicationManId)) {
                                    // 身份证号验证正确
                                    const param = {
                                        city_id: cascaderInfo,
                                        teamname: teamName,
                                        name: applicationManName,
                                        idno: applicationManId,
                                        mobile: applicationManPhone,
                                        sms: MessageVerification,
                                        sex: applicationManSex
                                    }
                                    // 当数据提交完成后需要将数据缓存到本地，以便等会获取
                                    app.setData('InitialInfo', param)
                                    this.props.setPage(3);


                                } else {
                                    app.alert("身份证号格式错误", "error")
                                }
                                // 身份证号验证正确
                                // const param = {
                                //     city_id: cascaderInfo,
                                //     teamname: teamName,
                                //     name: applicationManName,
                                //     idno: applicationManId,
                                //     mobile: applicationManPhone,
                                //     sms: MessageVerification,
                                //     sex: applicationManSex
                                // }
                                // 当数据提交完成后需要将数据缓存到本地，以便等会获取
                                // app.setData('InitialInfo', param)
                                // this.props.setPage(3);
                            } else {
                                app.alert("未选择申请人性别", "error")
                            }
                        } else {
                            app.alert("短信验证码未填写", "error")
                        }
                    } else {
                        app.alert("未填写申请人电话号码", "error")
                    }
                } else {
                    app.alert("未填写申请人身份证号", "error")
                }
            } else {
                app.alert("未填写申请人姓名", "error")
            }
        } else {
            app.alert("请先【查询队伍】", "error")
        }
    }











    // 创建状态
    //查询队伍是否存在
    checkTeam = () => {
        if (this.state.cascaderInfo.length > 1) {
            if (this.state.teamName != '') {
                const [city, bianhao] = this.state.cascaderInfo
                app.post(api.TeamCheckTeamname, { teamname: this.state.teamName }).then(res => {
                    if (res.flag == 1 && res.msg == "获取成功") {
                        if (res.data.usable) {
                            app.alert("当前队伍名可用", "success")
                            this.setState({
                                teamflag: true
                            })
                        } else {
                            app.alert("当前队伍名不可用", "error")
                            this.setState({
                                teamflag: false
                            })
                        }

                    } else {
                        app.alert("查询失败", "error")
                    }
                })

            } else {
                app.alert("队伍名称未填写", "error")

            }

        } else {
            app.alert("城市未选择", "error")
        }
    }
    // 【队伍信息填写end】













    // 暂存状态
    // 返回上一页需要从缓存中拿到页面所需要的数据
    getStorageInfo = () => {
        //如果没有暂存本地信息，那么不执行此方法
        if ( app.getData('InitialInfo') == '' || undefined ) {
            return
        }
        if (this.props.apply == 1 || this.props.examine == 1) {
            return
        }
        // console.log(app.getData('InitialInfo'))
        // 返回上一页后处理
        // 发送请求获取城市
        app.post(api.TeamProvinceCityList, {
        }).then(res => {
            if (res.flag === 1) {
                let provinceList = res.data.map((pro) => {
                    return {
                        label: pro.area_name,
                        value: pro.id,
                        children: (pro.city || []).map((city) => {
                            return {
                                label: city.city_name,
                                value: city.city_id,
                            }
                        }),
                    }
                })
                let defaultCity = ''
                if (app.getData('InitialInfo') != undefined) {
                    const InitialInfo = app.getData('InitialInfo')

                    provinceList.forEach((i, v) => {
                        if (InitialInfo.city_id == undefined) {
                            return
                        }
                        if (InitialInfo.city_id[0] == i.value) {
                            i.children.forEach((i2, v2) => {
                                if (i2.value == InitialInfo.city_id[1]) {
                                    defaultCity = i.label + '/' + i2.label


                                    this.setState({
                                        teamName: InitialInfo.teamname,
                                        applicationManName: InitialInfo.name,
                                        applicationManId: InitialInfo.idno,
                                        applicationManPhone: InitialInfo.mobile,
                                        applicationManSex: InitialInfo.sex,
                                        cascaderInfo: InitialInfo.city_id,
                                    })

                                }
                            })
                        }
                    })
                }

                if (app.getData('vname') != undefined) {
                    this.setState({
                        applicationManName: app.getData('vname'),
                        applicationManId: app.getData('idno'),
                        applicationManPhone: app.getData('mobile'),

                    })
                }



                this.setState({
                    provinceList,
                    defaultCity,

                })
            } else {
                app.alert("错误", "error")
            }
        })
    }


    // getLoginInfo = () =>{
    //     if(app.getData('vname') != undefined){  //如果vname不为undefined，那么说明用户已经登录了

    //     }
    // }










    // 详情状态
    getApplyinfo = () => {
        if (this.props.apply != 1) {
            return
        }
        // console.log(this.props)
        // const applyinfo = this.props.applyinfo;
        const applyinfo = app.getData('applyinfo');

        // console.log(applyinfo)

        app.post(api.TeamProvinceCityList, {
        }).then(res => {
            if (res.flag === 1) {
                let provinceList = res.data.map((pro) => {
                    return {
                        label: pro.area_name,
                        value: pro.id,
                        children: (pro.city || []).map((city) => {
                            return {
                                label: city.city_name,
                                value: city.city_id,
                            }
                        }),
                    }
                })
                let defaultCity = ''
                provinceList.forEach((i, v) => {
                    if (applyinfo.area_id == i.value) {
                        i.children.forEach((i2, v2) => {
                            if (i2.value == applyinfo.city_id) {
                                defaultCity = i.label + '/' + i2.label



                                // this.setState({
                                //     teamName: InitialInfo.teamname,
                                //     applicationManName: InitialInfo.name,
                                //     applicationManId: InitialInfo.idno,
                                //     applicationManPhone: InitialInfo.mobile,
                                //     applicationManSex: InitialInfo.sex,
                                //     cascaderInfo: InitialInfo.city_id,
                                // })
                            }
                        })
                    }
                })


                // console.log(defaultCity)
                this.setState({
                    teamName: applyinfo.teamname,
                    applicationManName: applyinfo.name,
                    applicationManId: applyinfo.idno,
                    applicationManPhone: applyinfo.mobile,
                    applicationManSex: applyinfo.sex,
                    cascaderInfo: [applyinfo.area_id, applyinfo.city_id],
                    provinceList,
                    defaultCity,

                }, () => {
                    // console.log("详情信息更新完成")
                    let info = {
                        cascaderInfo: this.state.cascaderInfo,
                        teamName: this.state.teamName,
                        applicationManName: this.state.applicationManName,
                        applicationManId: this.state.applicationManId,
                        applicationManPhone: this.state.applicationManPhone,
                        applicationManSex: this.state.applicationManSex,
                        MessageVerification: this.state.MessageVerification,
                        cascaderInfo: this.state.cascaderInfo
                    }
                    this.props.putModalInfo(info)
                })
            } else {
                app.alert("错误", "error")
            }
        })

    }

    // 提交编辑数据
    tijiao = () => {

        const state = this.state;
        let info = {
            cascaderInfo: state.cascaderInfo,
            teamName: state.teamName,
            applicationManName: state.applicationManName,
            applicationManId: state.applicationManId,
            applicationManPhone: state.applicationManPhone,
            applicationManSex: state.applicationManSex,
            MessageVerification: state.MessageVerification,
            cascaderInfo: state.cascaderInfo
        }
        this.props.compon1(info)
    }









    // 审核状态
    //获取审核详情数据
    getExamineInfo = () => {
        // console.log(this.props.examine)
        if (this.props.examine != 1) {
            return
        }

        // const examineInfo = this.props.examineInfo;
        const examineInfo = app.getData('examineInfo');

        // console.log(examineInfo)
        // this.setState({
        //     // cascaderInfo: examineInfo.city_name,
        //     defaultCity:examineInfo.city_name,
        //     teamName: examineInfo.teamname,
        //     applicationManName: examineInfo.name,
        //     applicationManId: examineInfo.idno,
        //     applicationManPhone: examineInfo.mobile,
        //     applicationManSex: examineInfo.sex,
        // }, () => {
        //     console.log(this.state.teamName)
        //     console.log(this.state.defaultCity)
        // })
        this.setState({
            defaultCity: examineInfo.city_name,
            teamName: examineInfo.teamname,
            applicationManName: examineInfo.name,
            applicationManId: examineInfo.idno,
            applicationManPhone: examineInfo.mobile,
            applicationManSex: examineInfo.sex,
        })


    }







    // 页面渲染区
    render() {
        // console.log(this.state.provinceList)
        // console.log(this.state)

        let { provinceList, teamflag } = this.state, lableTitle = { height: 40, paddingTop: 5, justifyItems: 'center', justifyContent: 'flex-end', marginBottom: 5 }
        return (
            <Spin spinning={this.state.spin}>
                <div >
                    {/* 队伍信息填写 */}
                    <div style={{ paddingBottom: 20 }}>
                        <h3 style={{ fontWeight: 'bold', fontSize: 18 }}>

                            {this.props.examine == 1 ? '队伍信息' : '队伍信息填写'}
                        </h3>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: 160, textAlign: 'right', fontSize: 16 }}>
                                <div style={{ height: 35 }} >申请队伍状态：</div>
                                <div style={{ height: 40, paddingTop: 5, marginBottom: 5 }}><span style={{ color: 'red' }}>*</span>申请城市：</div>
                                <div style={{ height: 40, paddingTop: 5 }}><span style={{ color: 'red' }}>*</span>申请队伍名称：</div>
                            </div>

                            {/* 表单内容 */}
                            <div style={{ fontSize: 16 }}>
                                <div style={{ height: 35 }}>筹备组</div>
                                <div style={{ height: 40, marginBottom: 5 }}>
                                    {/* <Cascader style={{ width: 400 }} options={options} onChange={this.getCity} placeholder="选择城市"></Cascader> */}

                                    {/* 默认创建状态为空，暂存为暂存值，申请、审核 */}

                                    <Cascader
                                        style={{ width: 400 }}
                                        options={provinceList}
                                        displayRender={(label) => label.join(' / ')}
                                        showSearch={true}
                                        onChange={this.getCity}
                                        placeholder={this.props.examine == 1 ? this.state.defaultCity : (this.state.defaultCity != '' ? this.state.defaultCity : '选择城市')}
                                        notFoundContent="无记录"
                                        disabled={this.props.examine == 1 || this.props.detailF == 1} />
                                    {/* || this.props.apply == 1 */}

                                </div>
                                <div style={{ height: 50 }}>

                                    <Input style={{ width: 400 }} placeholder="请输入申请队伍名" value={this.state.teamName} onChange={(e) => this.getTeamName(e)} disabled={this.props.examine == 1 || this.props.detailF == 1}></Input>
                                    {this.props.examine == 1 || this.props.detailF == 1 ? '' : <Button style={{ backgroundColor: '#1890FF', color: '#fff', marginLeft: 10 }} onClick={this.checkTeam} >查询队伍</Button>}
                                    {/* || this.props.apply == 1 */}

                                </div>

                            </div>

                            {/* 表单内容end */}

                        </div>

                        {/* 查询队伍时的提示信息 */}
                        <div style={{ paddingLeft: 160 }} hidden={teamflag == null}>
                            <p style={{ color: '#1ed76d' }} hidden={!teamflag}>该队伍名称可申请</p>

                            <p style={{ color: 'red' }} hidden={teamflag}>该队伍名称已被申请，请重新填写</p>
                        </div>
                        {/* 查询队伍时的提示信息end */}

                    </div>
                    {/* 队伍信息填写end */}


                    {/* 横线 */}
                    <hr style={{ opacity: 0.2 }} />
                    {/* 横线end */}


                    {/* 申请人信息填写 */}
                    <div style={{ paddingBottom: 40, paddingTop: 20 }}>
                        <h3 style={{ fontWeight: 'bold', fontSize: 18 }}>
                            {this.props.examine == 1 ? '申请人信息' : '申请人信息填写'}


                        </h3>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: 160, textAlign: 'right', fontSize: 16 }}>
                                <div style={lableTitle}><span style={{ color: 'red' }}>*</span>申请人姓名：</div>
                                <div style={lableTitle}><span style={{ color: 'red' }}>*</span>申请人身份证号码：</div>
                                <div style={lableTitle}><span style={{ color: 'red' }}>*</span>申请人手机号码：</div>
                                <div style={lableTitle} hidden={this.props.examine == 1 || this.props.detailF == 1}><span style={{ color: 'red' }}>*</span>短信验证码：</div>
                                <div style={{ height: 40, paddingTop: 5, justifyItems: 'center', justifyContent: 'flex-end' }}><span style={{ color: 'red' }}>*</span>性别：</div>

                            </div>
                            {/* 表单内容 */}
                            <div style={{ fontSize: 16 }}>
                                <div style={{ height: 40, marginBottom: 5 }}>
                                    <Input
                                        style={{ width: 400 }}
                                        placeholder="请输入申请人姓名"
                                        value={this.state.applicationManName}
                                        onChange={(e) => this.applicationManNameOnchange(e)}
                                        maxLength={8}
                                        disabled={this.props.examine == 1 || this.props.detailF == 1 || app.getData('vname') ? true : false}></Input>
                                </div>
                                <div style={{ height: 40, marginBottom: 5 }}>
                                    <Input
                                        style={{ width: 400 }}
                                        placeholder="请输入申请人身份证号码"
                                        value={this.state.applicationManId}
                                        onChange={(e) => this.applicationManIdOnchange(e)}
                                        maxLength={18}
                                        disabled={this.props.examine == 1 || this.props.detailF == 1 || app.getData('idno') ? true : false}></Input>
                                </div>
                                <div style={{ height: 40, marginBottom: 5 }}>
                                    <Input style={{ width: 400 }} placeholder="请输入申请人手机号码" value={this.state.applicationManPhone} onChange={(e) => this.applicationManPhoneOnchange(e)} maxLength={11} disabled={this.props.examine == 1 || this.props.detailF == 1}></Input>
                                </div>
                                <div style={{ height: 40, marginBottom: 5 }} hidden={this.props.examine == 1 || this.props.detailF == 1}>
                                    <Input style={{ width: 200 }} placeholder="请输入短信验证码" value={this.state.MessageVerification} onChange={(e) => this.applicationManMessageVerificationOnchange(e)} disabled={this.props.examine == 1 || this.props.detailF == 1} ></Input>
                                    {this.props.examine == 1 || this.props.detailF == 1 ? '' : <Button style={{ backgroundColor: '#1890FF', color: '#fff', marginLeft: 10 }} onClick={this.clickGetMessageVerification}>获取验证码</Button>}

                                </div>
                                <div style={{ height: 40, paddingTop: 3 }}>
                                    <RadioGroup options={[
                                        { label: '男', value: '男' },
                                        { label: '女', value: '女' },
                                    ]} value={this.state.applicationManSex} onChange={this.sexChange} disabled={this.props.examine == 1 || this.props.detailF == 1} />

                                </div>
                            </div>
                            {/* 表单内容end */}

                        </div>
                    </div>
                    {/* 申请人信息填写end */}



                    {/* 功能按钮 */}
                    <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} hidden={this.state.Editor == 2}>
                        <Button style={{ width: 300, marginRight: 50 }} onClick={this.golast}>上一步</Button>
                        <Button style={{ width: 300, marginLeft: 50, backgroundColor: '#1890FF', color: '#fff' }} onClick={this.goNext}>下一步</Button>
                    </div>
                    {/* 功能按钮end */}

                    <div style={{ paddingTop: 80, display: 'flex', justifyContent: 'center' }} >
                        {
                            this.props.examine == 1 || this.props.detailF == 1 ? '' : this.state.Editor == 2 ? <Button style={{ width: 300, backgroundColor: '#1890FF', color: '#fff', }} onClick={this.tijiao}>确认修改</Button> : ''

                        }
                    </div>

                </div>

            </Spin>

        )
    }
}



export default InformationFilling



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/InformationFilling.jsx